import React, { useState } from 'react';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import * as XLSX from 'xlsx';
import ExportToExcel from '../Components/ExportToExcel';

const NIID_USERNAME = 'eil';
const NIID_PASSWORD = 'tpKh7iVx9cxl1ZD';

export default function TestGetRegistration1() {
    const [registrationNumbers, setRegistrationNumbers] = useState([]);
    const [registrationDetails, setRegistrationDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fails, setFails] = useState([]);

    const onDrop = async (acceptedFiles) => {
        setLoading(true);

        const file = acceptedFiles[0];
        if (!file) {
            setLoading(false);
            return;
        }

        const reader = new FileReader();

        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            const regNumbers = rows
                .map((row) => row?.[0])
                .filter((value) => typeof value === 'string' || typeof value === 'number')
                .map((value) => String(value).trim())
                .filter(Boolean);

            setRegistrationNumbers(regNumbers);
            setRegistrationDetails([]);
            setFails([]);

            let failRecs = [];
            let retryRecs = [];
            let retryList = [];
            let regData = [];

            const fetchData = async (regNumber) => {
                try {
                    const response = await axios.get('https://rest.niid.org/api/motorinsurance/verify', {
                        params: {
                            sv: regNumber,
                            st: 'REGISTRATIONNUMBER',
                            un: NIID_USERNAME,
                            pw: NIID_PASSWORD,
                        },
                    });

                    if (response?.data?.policyStatus && response.data.policyStatus !== 'NOT FOUND') {
                        return {
                            regNo: response?.data?.regNo || regNumber,
                            ownerName: response?.data?.insured,
                            mobileNo: response?.data?.phoneNumber,
                            vehicleMake: response?.data?.vehicleMake,
                            vehicleModel: response?.data?.vehicleModel,
                            chassis: response?.data?.chassis,
                            policyNumber: response?.data?.policyNumber,
                            engineNo: response?.data?.engineNo,
                            color: response?.data?.color,
                            address: response?.data?.address,
                            yearOfMake: response?.data?.yearOfMake,
                            issueDate: response?.data?.issueDate,
                            expiryDate: response?.data?.expiryDate,
                            policyStatus: response?.data?.policyStatus,
                            coverType: response?.data?.coverType,
                        };
                    }

                    if (response?.data?.policyStatus === 'NOT FOUND') {
                        failRecs.push(regNumber);
                        return null;
                    } else {
                        retryRecs.push(regNumber);
                        return null;
                    }
                } catch (error) {
                    retryRecs.push(regNumber);
                    return null;
                }
            };

            const processRetryList = async () => {
                let regDetails = [];
                let currentRetrylist = retryList;

                while (currentRetrylist.length > 0) {
                    try {
                        const detailsPromises = currentRetrylist.map(fetchData);
                        const detailsData = await Promise.all(detailsPromises);
                        const successfulDetails = detailsData.filter((item) => item !== null);
                        regDetails = [...regDetails, ...successfulDetails];
                        setFails(failRecs);

                        currentRetrylist = [...retryRecs];
                        retryRecs = [];
                        continue;
                    } catch (error) {
                    }
                }

                return regDetails;
            };

            if (regNumbers.length > 500) {
                const partitions = {};
                for (let i = 0; i < regNumbers.length; i += 500) {
                    partitions[i] = regNumbers.slice(i, i + 500);
                }

                for (const partition in partitions) {
                    retryList = partitions[partition];
                    const currentRegData = await processRetryList();
                    regData = [...regData, ...currentRegData];
                }
                setRegistrationDetails(regData);
            } else {
                retryList = regNumbers;
                const currentRegData = await processRetryList();
                setRegistrationDetails(currentRegData);
            }

            setLoading(false);
        };

        reader.readAsArrayBuffer(file);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    return (
        <div style={{ padding: '150px 100px' }}>
            {!loading && (
                <div
                    {...getRootProps()}
                    style={{ border: '1px dashed black', padding: '120px', textAlign: 'center', cursor: 'pointer' }}
                >
                    <input {...getInputProps()} />
                    {isDragActive ? (
                        <p>Drop the file here ...</p>
                    ) : (
                        <p>Drag 'n' drop an Excel file here, or click to select one</p>
                    )}
                </div>
            )}

            {loading && <h3 className="mb-30 text-center">Loading...</h3>}

            <div className="section-top-border">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h3 className="mb-30">Result</h3>
                    {!loading && (
                        <div>
                            <ExportToExcel
                                data={registrationDetails}
                                fileName={'NIID Registration Number Search Result ' + Date.now()}
                            />
                        </div>
                    )}
                </div>

                <div className="progress-table-wrap">
                    <div className="progress-table">
                        <div className="table-head">
                            <div className="serial">#</div>
                            <div className="country">Reg No</div>
                            <div className="visit">Name</div>
                            <div className="percentage">Phone</div>
                        </div>
                        {registrationDetails.map((item, index) => (
                            <div key={index} className="table-row">
                                <div className="serial">{index + 1}</div>
                                <div className="serial">{item?.regNo}</div>
                                <div className="country">{item?.ownerName}</div>
                                <div className="visit">{item?.mobileNo}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div>
                <h3 className="mb-30">Fails</h3>
                <ul>
                    {fails.map((number, index) => (
                        <li key={index}>
                            {index}) Registration Number: {number}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
